import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { api } from './api';
import { Spinner, Header, Page } from './components.jsx';
import HomePage from './pages/HomePage.jsx';
import ManagePage from './pages/ManagePage.jsx';

export default function App() {
  const [state, setState] = useState({ loading: true, user: null });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    api
      .get('/api/me')
      .then((d) => setState({ loading: false, user: d.user }))
      .catch(() => setState({ loading: false, user: null }));
  }, []);

  if (state.loading) {
    return (
      <>
        <Header />
        <Spinner label="Signing you in…" />
      </>
    );
  }

  if (!state.user) {
    return (
      <>
        <Header />
        <Page>
          <div className="card p-6 text-center">
            <p className="mb-4">You need to sign in to continue.</p>
            <a className="btn-primary" href="/auth/login">Sign in with PocketID</a>
          </div>
        </Page>
      </>
    );
  }

  const { user } = state;
  return (
    <Routes>
      <Route
        path="/"
        // HomePage renders its own Header, since it owns the sections the
        // header's jump-to menu points at.
        element={<HomePage user={user} editMode={editMode} onToggleEdit={() => setEditMode((v) => !v)} />}
      />
      <Route
        path="/manage/*"
        element={
          user.role === 'manager' ? (
            <>
              <Header user={user} />
              <ManagePage user={user} />
            </>
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
